import { recordPath, recordRoute } from '@/shared/registry'

/** Where the company pages live. */
export const companiesPath = '/site-management/companies'
export const createCompanyPath = `${companiesPath}/new`
export const companyRoute = recordRoute('site-management', 'companies')
export const editCompanyRoute = `${companyRoute}/edit`

/** A company's details page. */
export function companyPath(id: string): string {
  return recordPath('site-management', 'companies', id)
}

/** The base of Company Details' slots (`detailsSlots`). */
export const companyDetailsSlot = 'site-management.company-details'

/** The API's company endpoints. */
export const companiesApi = '/site-management/v1/companies'

export function companyApi(id: string): string {
  return `${companiesApi}/${encodeURIComponent(id)}`
}

/** Merges one company into another. */
export const mergeCompaniesApi = `${companiesApi}/merge`

/** What each company action needs. */
export const readCompaniesPermission = 'site-management.companies.read'
export const writeCompaniesPermission = 'site-management.companies.write'
export const deleteCompaniesPermission = 'site-management.companies.delete'
export const mergeCompaniesPermission = 'site-management.companies.merge.write'
